import React from "react";
import Alert from "@mui/material/Alert";

export interface ConcurrentEditingAlertProps {
  /** Name of the user holding the edit lock; falls back to "Another user" when unknown */
  editingUserFullName: string | null;
  /** What's locked, as it should read in the sentence (e.g. "notice", "application") */
  itemLabel: string;
}

/** Fixed toast telling a user that someone else is editing the item, so their actions are disabled. */
export const ConcurrentEditingAlert: React.FC<ConcurrentEditingAlertProps> = ({ editingUserFullName, itemLabel }) => (
  <Alert
    severity="info"
    sx={{
      position: "fixed",
      bottom: 16,
      right: 16,
      zIndex: 1000,
      maxWidth: 400,
    }}
  >
    {editingUserFullName || "Another user"} is currently editing this {itemLabel}. You will not be able to make changes.
  </Alert>
);

export default ConcurrentEditingAlert;
